import type { Referral } from 'src/types/Subscription';

// earned is the programme's cumulative calculation, not the spendable bonus balance.
export function readReferrals(value: unknown): Referral[] {
    if (!Array.isArray(value)) throw new Error('Invalid referral response');
    const ids = new Set<number>();
    return value.map((row) => {
        const raw = row?.earned;
        const earned =
            typeof raw === 'number'
                ? raw
                : typeof raw === 'string' && /^\d+(\.\d{1,2})?$/.test(raw)
                ? Number(raw)
                : NaN;
        if (
            !Number.isSafeInteger(row?.id) ||
            row.id <= 0 ||
            ids.has(row.id) ||
            typeof row.email !== 'string' ||
            !row.email.trim() ||
            !Number.isFinite(earned) ||
            earned < 0 ||
            !Number.isSafeInteger(Math.round(earned * 100))
        ) {
            throw new Error('Invalid referral response');
        }
        ids.add(row.id);
        return { id: row.id, email: row.email, earned };
    });
}

export function totalReferralEarnings(rows: Referral[]): number {
    return rows.reduce((sum, row) => sum + Math.round(row.earned * 100), 0) / 100;
}

export function formatReferralEarnings(amount: number): string {
    return amount.toLocaleString('ru-RU', { maximumFractionDigits: 2 });
}
